export const translationForDomainKeys = {
  header: {
    amountOfCodes: '<0>{{amount}} of {{max}}</0> QR codes',
  },
  subscription: {
    chooseTheMostSuitablePackage: 'Choose the most suitable package',
    selectAPlan: 'Select a plan',
    trialPlanEndsIn: 'Trial plan ends in:',
    active: 'Active',
    activeUntil: 'Active until',
    canceled: 'Canceled',
    billMonthly: 'Bill monthly',
    billYearly: 'Bill yearly',
    selectCurrency: 'Select currency',
    currency: 'Currency',
    dynamicQRCodes: 'Dynamic QR Codes',
    month: 'month',
    upgradeTo: 'Upgrade to',
    subscribedToSuccessfuly: 'Subscribed to {{planName}} successfuly',
    changeToMonthly: 'Change to monthly',
    changeToYearly: 'Change to yearly',
    monthly: 'monthly',
    yearly: 'yearly',
    notAvailable: 'Not available',
    currentPlan: 'Current Plan',
    buttonUpgradePlan: 'Upgrade Plan',
    cancelPlan: 'Cancel Plan',
    renewPlan: 'Renew Plan',
    areYouSureToCancelPlan: 'Are you sure you want to cancel {{planName}} plan?',
    youCanRenewBeforeTheExpirationDate: 'You can renew it before the expiration date.',
    planCancelledCodesValidUntilDate:
      '{{planName}} plan cancelled. Codes generated during the {{planName}} plan are valid until {{expireDate}}',
    includes: 'Includes',
    seeAllFeatures: 'See All Features',
    seeLessFeatures: 'See Less Features',
    feature: {
      maxScans: 'scans',
      templates: 'Templates',
      labels: 'Labels',
      realTimeDataDashboard: 'Real time data dashboard',
      tracksScansTimeOfDay: 'Tracks scans/time of day',
      tracksScansLocations: 'Tracks scans/locations',
      tracksScansDeviceType: 'Tracks scans/device type',
      tracksScansGPSCoordinates: 'Tracks scans/GPS coordinates ',
      qrDesignCustomisations: 'QR design customisations ',
      bulkQRCodeGeneration: 'Bulk QR Code generation',
      gdprCompliant: 'GDPR compliant',
      ccpaCompliant: 'CCPA compliant',
      knowledgeBase: 'Knowledge base',
      emailSupport: 'Email support',
      dedicatedCustomerSuccessManager: 'Dedicated customer success manager',
    },
    faq: {
      question1: 'What if something 1?',
      answer1: 'Yes, you can do it. For more details please contact our support 1.',
      question2: 'What if something 2?',
      answer2: 'Yes, you can do it. For more details please contact our support 2.',
      question3: 'What if something 3?',
      answer3: 'Yes, you can do it. For more details please contact our support 3.',
    },
    planError: {
      MAX_QR_CODE_USED_RESTRICTION: 'You have more QR codes in your account than the limit of this plan',
      PLAN_TEMPLATE_RESTRICTION: 'You used templates that are included in the STARTER package',
      PLAN_GPS_RESTRICTION: 'You used GPS tracking that is included in the STARTER package',
      PLAN_SCAN_RESTRICTION: 'You have more scans of QR codes than the limit of this plan',
    },
  },
  qr: {
    entityName: 'QR code',
    createQRCode: 'Create QR Code',
    editQRCode: 'Edit QR Code',
    preview: 'Preview',
    buttonNext: 'Next',
    buttonBack: 'Back',
    buttonConfirm: 'Confirm',
    buttonAndSave: 'And Save',
    buttonSaveChanges: 'Save changes',
    buttonDownload: 'Download',
    scans: 'Scans',
    expired: {
      qrCodeNoLongerValid: 'QR code is no longer valid',
      activateYourQr: 'Activate your qr now or share this link with the owner.',
      reactivateThisQRCode:
        'Reactivate this QR code if you are the owner or share this link with the owner of this QR code.',
      buttonClaimAndActivate: 'Claim and activate QR',
    },
    stepType: {
      stepTitle: 'Type',
      selectYourQRCodeType: 'Select your QR Code type',
      websiteURL: 'Website URL',
      websiteDescription: 'Website link to QR code',
      vCard: 'vCard Plus',
      vCardDescription: 'Your digital business card',
    },
    stepInput: {
      stepTitle: 'Input',
    },
    stepCustomize: {
      stepTitle: 'Customize',
      logo: {
        tabTitle: 'Logo',
        description: 'Use an existing logo or add a new one using the + button. Format: PNG, max file size 5MB.',
        noLogo: 'No logo',
        deleteLogo: 'Delete logo?',
        yesDelete: 'Yes, delete',
      },
      frame: {
        tabTitle: 'Frame',
        noFrame: 'No frame',
      },
      pattern: {
        tabTitle: 'Pattern',
      },
      template: {
        tabTitle: 'Template',
        saveDesign: 'Save Design',
      },
    },
    stepDone: {
      stepTitle: 'Done',
      almostReady: 'Almost ready!',
      enterNameForYourQRCode: 'Enter a name for your QR code',
    },
    design: {
      frameCustomText: 'Custom text',
      frameTextSize: 'Size',
      frameTextColor: 'Text color',
      frameBackgroundColor: 'Frame background color',
      patternColor: 'QR pattern color',
      backgroundColor: 'QR background color',
      cornerColor: 'Corners color',
    },
    websiteInput: {
      title: 'Website URL',
      enterURL: 'Enter URL',
      yourCodeGeneratedAutomatically: 'Your QR Code will be generated automatically',
    },
  },
  template: {
    createTemplate: 'Create template',
    editTemplate: 'Edit template',
    title: 'Title',
    enterName: 'Enter a name for your template',
  },
} as const;
